import { createApp, setup } from '@/setup'

export const WidgetHelper = {
  registerWidget(component, element) {
    const props = element.dataset

    const instance = setup(createApp(component, props))
    instance.mount(element)
  },
  reTry(widgetSelector, component, currentAttempt = 1, maxAttempts = 4) {
    const widgets = document.querySelectorAll(widgetSelector)
    if (widgets.length) {
      widgets.forEach(element => {
        this.registerWidget(component, element)
      })
    } else if (currentAttempt <= maxAttempts) {
      window.setTimeout(() => this.reTry(widgetSelector, component, currentAttempt + 1), 2500)
    }
  },
}
